import React from 'react'

import { PatientContact } from '../components/FormComponents/PatientContact';



export const NewPatient = () => {
    return (
      <div>
        <PatientContact/>
      </div>
    );
  };
  
 
